export const apiConfig = {
  login: "/v1/login/",
  logout: "/v1/logout/",
  users: "/v1/users/",
  createUser: "/v1/user/",
  getUserById: "/v1/user/",
  updateUser: "/v1/user/",
  deleteUser: "/v1/user/",
  changePassword: "/v1/change-password/",
  salesOverview: "/v1/analytics/sales-overview",
  analytics: "/v1/analytics",
  generalOverview: "/v1/analytics/general-overview",
  profitAndLoss: "/v1/analytics/pnl-overview",
  expenses: "/v1",
  adCheker: "/v1/social",
  products: "/v1/analytics/product-overview",
  shopifyOAuthLink: "/v1/shopify_oauth_link/",
  shopifyExchangeCode: "/v1/shopify_exchange_code/",
};
